// extracted by mini-css-extract-plugin
module.exports = {"danger":"SnackBarMessage_danger__3dw6P","success":"SnackBarMessage_success__1dCSj"};